import React, {useState} from "react";
import Popup from "../components/Popup";
import WebinarFormPopup from "../components/WebinarFormPopup";
import { FaVideo, FaTools, FaInfinity, FaBriefcase } from "react-icons/fa";
import CoursetFreeTrial from "../components/CoursetFreeTrial";
import OffersBanner from "../components/OffersBanner";
import Pricing from "../components/Pricing";
import WhatMakes from "../components/WhatMakes";
import CourseClassesSection from "../components/CourseClassesSection";
import OffersStories from "../components/OffersStories";
import OffersFreeTrial from "../components/OffersFreeTrial";
import StepsSection from "../components/StepsSection";
import ContactBanner from "../components/ContactBanner";
import ContactSection from "../components/ContactSection";
import GoogleMap from "../components/GoogleMap";


function Contact() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  const courseData = {
  highlights: [
{ icon: <FaVideo />, text: "350+ Live sessions" },
  { icon: <FaTools />, text: "15+ Industry Projects" },
  { icon: <FaInfinity />, text: "Lifetime accessibility" },
  { icon: <FaBriefcase />, text: "Live project experience" },
  ],
  title: "Basic Level: Spoken English Course Content",
  description:
    "This course is designed for individuals who can read and write English but lack confidence and fluency in speaking. The focus is on practical communication skills and real-world application.",
  // price: "120,000",
  emi: "5,900",
  applyLink: "#apply",

  batchDate: { day: "19", month: "AUG", batch: "Morning" },
  batchName: "Next Advanced Level: Spoken English",
  batchDays: "Sat - Sun",
  batchTime: "09:00 am - 12:00 pm",
  batchSeat: "Available",
  batchVenue: "Virtual Hall",
  enrollLink: "#enroll",
};
  return (
    <>
    <ContactBanner />
    <ContactSection />
    {/* <GoogleMap /> */}


<Popup isOpen={isPopupOpen} onClose={closePopup}>
  <WebinarFormPopup onClose={closePopup} />
</Popup>


    </>
  );
}

export default Contact;
